import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { UserRole } from "../../../common/enums/user-role.enum";
import { LoaderView } from "../../loader/loader.comp";
import NotFound from "../../../views/not-found/not-found";

const AdminProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { user, isSuperAdmin } = FirebaseAuthContainer.useContainer();
    const isAdminOrSuperAdmin = isSuperAdmin || user?.role === UserRole.admin;

    return user ? isAdminOrSuperAdmin ? children : <NotFound /> : <LoaderView show={true} />;
};

export default AdminProtectedRoute;
